import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import FiveMinsAppointmentBooking from './FiveMinsAppointmentBooking';
import {APPOINTMENT_BOOKING_TYPE} from '~/constants/appointment-bookings';
import TenMinsAppointmentBooking from './TenMinsAppointmentBooking';
import StdTestingAppointmentBooking from './StdTestingAppointmentBooking';
import BcRenewalAppointmentBooking from './BcRenewalAppointmentBooking';
import ThirtyMinsAppointmentBooking from './ThirtyMinsAppointmentBooking';
import {METHOD_KEYS} from '~/constants/medical-questionnaires';
import {trackPageViewGA} from '~/services/google-analytics';
import {convertUpperSnakeCaseToNormal} from '~/utils/helpers';
const queryString = require('query-string');

interface AppointmentRouteParams {
  type: string;
  methodKey: string;
}

const AppointmentBooking = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);

  const location = window.location;
  const query: AppointmentRouteParams = queryString.parse(location.search);

  const methodKeyName = convertUpperSnakeCaseToNormal(query.methodKey || '');

  useEffect(() => {
    if (query.methodKey === METHOD_KEYS.BIRTH_CONTROL_REFILL && query.type === APPOINTMENT_BOOKING_TYPE.FIVE_MINS) {
      trackPageViewGA(`/appointments/refill`, `MDQ-Appointment refill - ${methodKeyName}`);
      return;
    }
    switch (query.type) {
      case APPOINTMENT_BOOKING_TYPE.FIVE_MINS:
        trackPageViewGA(`/appointments/5-mins`, `MDQ-Appointment 5 mins - ${methodKeyName}`);
        break;
      case APPOINTMENT_BOOKING_TYPE.TEN_MINS:
        trackPageViewGA(`/appointments/10-mins`, `MDQ-Appointment 10 mins - ${methodKeyName}`);
        break;
      case APPOINTMENT_BOOKING_TYPE.THIRTY_MINS:
        trackPageViewGA(`/appointments/30-mins`, `MDQ-Appointment 30 mins - ${methodKeyName}`);
        break;
      case APPOINTMENT_BOOKING_TYPE.STD_TESTING:
        trackPageViewGA(`/appointments/std-testing`, `MDQ-Appointment - ${methodKeyName}`);
        break;
      case APPOINTMENT_BOOKING_TYPE.BC_RENEWAL_12_MONTHS:
        trackPageViewGA(`/appointments/refill`, `MDQ-Appointment refill - ${methodKeyName}`);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        break;
    }
  }, [methodKeyName, query.methodKey, query.type]);

  const renderAppointment = () => {
    if (query.methodKey === METHOD_KEYS.BIRTH_CONTROL_REFILL && query.type === APPOINTMENT_BOOKING_TYPE.FIVE_MINS) {
      return <BcRenewalAppointmentBooking />;
    }
    switch (query.type) {
      case APPOINTMENT_BOOKING_TYPE.FIVE_MINS:
        return <FiveMinsAppointmentBooking />;
      case APPOINTMENT_BOOKING_TYPE.TEN_MINS:
        return <TenMinsAppointmentBooking />;
      case APPOINTMENT_BOOKING_TYPE.THIRTY_MINS:
        return <ThirtyMinsAppointmentBooking />;
      case APPOINTMENT_BOOKING_TYPE.STD_TESTING:
        return <StdTestingAppointmentBooking />;
      case APPOINTMENT_BOOKING_TYPE.BC_RENEWAL_12_MONTHS:
        return <BcRenewalAppointmentBooking />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderAppointment();
};

export default AppointmentBooking;
